// Connection Service for Peer to Peer 
class PeerConnectionManager {
    constructor() {
        this.isHost = false;
        this.peer = null;
        this.channel = null;
        this.clients = new Map();
        this.status = "closed";
        this.listeners = new Set();
        this.messageListeners = new Set();
        this.clientConnectedListeners = new Set();
    }

    setHostConnection(peer, channel) {
        this.isHost = false;
        this.peer = peer;
        this.channel = channel;
        this.status = "connected";
        this.attachChannel(channel);
        this.notify();
    }

    addClient(id, peer, channel) {
        this.isHost = true;
        this.clients.set(id, {
            peer,
            channel
        });

        this.attachChannel(channel, id);
        this.status = "connected";
        this.notify();

        // Listener informieren, dass ein neuer Client verbunden ist
        this.clientConnectedListeners.forEach((callback) => {
            callback(id);
        });
    }


    attachChannel(channel, clientId = null) {
        channel.onmessage = (event) => {
            const data = JSON.parse(event.data);

            this.messageListeners.forEach((callback) => {
                callback({
                    clientId,
                    data
                });
            });
        };


        channel.onclose = () => {
            if (clientId) {
                this.clients.delete(clientId);
            } else {
                this.close();
            }

            this.notify();
        };
    }


    send(data, clientId = null) {
        if (this.isHost) {

            // Nur ein bestimmter Client
            if (clientId) {
                const client =
                    this.clients.get(clientId);

                if (!client) {
                    console.warn(
                        "Client nicht gefunden:",
                        clientId
                    );
                    return;
                }

                client.channel.send(
                    JSON.stringify(data)
                );

                return;
            }

            // Alle Clients
            this.broadcast(data);

            return;
        }

        // Client -> Host
        if (
            !this.channel ||
            this.channel.readyState !== "open"
        ) {
            console.warn(
                "Keine offene Verbindung"
            );
            return;
        }

        this.channel.send(
            JSON.stringify(data)
        );
    }


    sendToClient(clientId, data) {
        const client =
            this.clients.get(clientId);

        if (!client) {
            return;
        }

        client.channel.send(
            JSON.stringify(data)
        );
    }


    broadcast(data) {
        this.clients.forEach((client, id) => {
            if (
                client.channel.readyState === "open"
            ) {
                client.channel.send(
                    JSON.stringify(data)
                );
            }
        });
    }

    onMessage(callback) {
        this.messageListeners.add(callback);
        return () => {
            this.messageListeners.delete(callback);
        };
    }

    onClientConnected(callback) {
        this.clientConnectedListeners.add(callback);
        return () => {
            this.clientConnectedListeners.delete(callback);
        };
    }

    subscribe(callback) {
        this.listeners.add(callback);
        return () => {
            this.listeners.delete(callback);
        };
    }

    notify() {
        this.listeners.forEach((callback) => {
            callback(this.status);
        });
    }


    isConnected() {
        return this.status === "connected";
    }


    getStatus() {
        return this.status;
    }

    close() {
        if (this.channel) {
            this.channel.close();
        }

        if (this.peer) {
            this.peer.close();
        }

        this.clients.forEach((client) => {
            client.channel.close();
            client.peer.close();
        });

        this.clients.clear();
        this.peer = null;
        this.channel = null;
        this.status = "closed";
        this.notify();
    }
}


export default new PeerConnectionManager();